<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
        <input
            :id="id"
            ref="input"
            v-bind="{ ...$attrs, class: null }"
            :class="[inputClass, { error: error }]"
            :type="type"
            :checked="checkedValue"
            :value="type !== 'checkbox' ? modelValue : undefined"
            @input="handleInput"
        />
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`;
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        error: String,
        label: String,
        modelValue: [String, Number, Boolean],
    },
    emits: ['update:modelValue'],
    computed: {
        inputClass() {
            return this.type === 'checkbox' ? 'form-checkbox' : 'form-input';
        },
        checkedValue() {
            return this.type === 'checkbox' ? !!this.modelValue : this.modelValue;
        },
    },
    methods: {
        handleInput(event) {
            const value = this.type === 'checkbox' ? event.target.checked : event.target.value;
            this.$emit('update:modelValue', value);
        },
        focus() {
            this.$refs.input.focus();
        },
        select() {
            this.$refs.input.select();
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end);
        },
    },
};
</script>
